import {Alert, Box, Button, CircularProgress, Stack, TextField, Typography} from '@mui/material';
import React, {useEffect, useState, useRef} from 'react';
import {Link, useLocation, useSearchParams} from 'react-router-dom';
import axios from 'axios';
import {API_ENDPOINT} from '../config';

export default function AccountActivationPage() {
    const [params, setParams] = useSearchParams();
    const [token] = useState(() => params.get('token') || '');
    // Acelasi flux si pentru resetarea parolei de catre admin (pasul 24): doar textele difera.
    // Pasul 39: /resetare-parola = „Ai uitat parola?” (alt endpoint, link cerut din nou de utilizator).
    const uitata = useLocation().pathname === '/resetare-parola';
    const [resetare] = useState(() => uitata || params.get('tip') === 'resetare');
    const [password, setPassword] = useState('');
    const [confirmation, setConfirmation] = useState('');
    const [error, setError] = useState('');
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);
    const pending = useRef(false);
    const validToken = /^[a-f0-9]{64}$/.test(token);
    const endpoint = `${API_ENDPOINT}/public/${uitata ? 'resetare-parola' : 'activare-cont'}`;
    // Pasul 51.7: linkul se verifica inainte de campurile de parola: valid / activat / expirat / invalid.
    // Daca verificarea nu raspunde (retea), formularul apare oricum - serverul verifica din nou la trimitere.
    const [stare, setStare] = useState(validToken ? 'verificare' : 'invalid');
    useEffect(() => {
        if (!validToken) return undefined;
        let activ = true;
        axios.post(`${endpoint}/stare`, {token})
            .then(() => activ && setStare('valid'))
            .catch(e => activ && setStare(['activat', 'expirat', 'invalid'].includes(e.response?.data?.stare) ? e.response.data.stare : 'valid'));
        return () => {activ = false;};
    }, [endpoint, token, validToken]);
    const submit = async event => {
        event.preventDefault();
        if (pending.current) return;
        if (password !== confirmation) {setError('Parolele nu coincid.'); return;}
        pending.current = true;
        setBusy(true);
        setError('');
        try {
            await axios.post(endpoint, {token, password});
            setDone(true);
            setPassword('');
            setConfirmation('');
            setParams({}, {replace: true});
        } catch (e) {
            // Pasul 51.7: al doilea click / link expirat intre timp - mesajul, fara formular.
            if (['activat', 'expirat', 'invalid'].includes(e.response?.data?.stare)) {setStare(e.response.data.stare); return;}
            setError(e.response?.data?.detail || (resetare ? 'Schimbarea parolei nu a reușit. Reîncearcă.' : 'Activarea nu a reușit. Reîncearcă.'));
        } finally {pending.current = false; setBusy(false);}
    };
    return <Box sx={{maxWidth: 520, mx: 'auto', px: 2, py: 5}}>
        <Typography component="h1" variant="h4" sx={{mb: 3}}>{resetare ? 'Setează parola nouă' : 'Activează contul'}</Typography>
        {done ? <><Alert severity="success" role="status">{resetare ? 'Parola a fost schimbată.' : 'Contul a fost activat.'} Te poți autentifica folosind emailul și parola aleasă.</Alert><Button component={Link} to="/login" sx={{mt: 2}}>Autentificare</Button></>
            : stare === 'verificare' ? <Box sx={{display: 'flex', justifyContent: 'center', py: 4}}><CircularProgress aria-label="Se verifică linkul" /></Box>
            : stare === 'activat' ? <><Alert severity="info">{resetare ? 'Parola a fost deja setată cu acest link.' : 'Contul este deja activat.'} Te poți autentifica folosind emailul și parola aleasă.</Alert><Button component={Link} to="/login" variant="contained" sx={{mt: 2}}>Autentificare</Button></>
            : stare !== 'valid' ? <Alert severity="error">{stare === 'expirat' ? 'Linkul a expirat.' : 'Link invalid.'} {uitata ? <>Cere din nou <Link to="/parola-uitata">resetarea parolei</Link>.</> : resetare ? 'Cere administratorului o nouă resetare a parolei.' : 'Solicită o invitație nouă administratorului.'}</Alert>
            : <Stack component="form" onSubmit={submit} spacing={3}>
                {error && <Alert severity="error">{error}</Alert>}
                <TextField id="activation-password" label="Parolă nouă" type="password" autoComplete="new-password" required inputProps={{minLength: 12, maxLength: 72, 'aria-label': 'Parolă nouă'}} helperText="Minimum 12 caractere."
                    value={password} onChange={e => setPassword(e.target.value)} disabled={busy} />
                <TextField id="activation-confirm" label="Confirmă parola" type="password" autoComplete="new-password" required inputProps={{'aria-label': 'Confirmă parola'}}
                    value={confirmation} onChange={e => setConfirmation(e.target.value)} disabled={busy} />
                <Button type="submit" variant="contained" disabled={busy}>{busy ? 'Se salvează…' : resetare ? 'Salvează parola' : 'Activează contul'}</Button>
            </Stack>}
    </Box>;
}
